import { useEffect, useState } from 'react'
import {
  AlertDialog,
  AlertDialogBody,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogContent,
  AlertDialogOverlay,
  AlertDialogCloseButton,
  Button,
  FormControl,
  FormLabel,
  Input
} from '@chakra-ui/react'
import { useIntl } from 'react-intl'
import messages from './messages'

interface Props {
  isOpen: boolean
  onClose: () => void
  onConfirm: (reason: string) => void
  cancelRef: any
}

export default function PatientForm({
  isOpen,
  onClose,
  onConfirm,
  cancelRef
}: Props) {
  const { formatMessage } = useIntl()
  const [reason, setReason] = useState('')
  useEffect(() => {
    if (isOpen) setReason('')
  }, [isOpen])
  return (
    <AlertDialog
      isOpen={isOpen}
      leastDestructiveRef={cancelRef}
      onClose={onClose}
    >
      <AlertDialogOverlay
        bg="blackAlpha.300"
        backdropFilter="blur(10px) hue-rotate(90deg)"
      >
        <AlertDialogContent>
          <AlertDialogHeader fontSize="lg" fontWeight="bold">
            {formatMessage(messages.deleteVisit)}
          </AlertDialogHeader>
          <AlertDialogCloseButton />

          <AlertDialogBody>
            {formatMessage(messages.confirmText)}
            <FormControl mt={4} isRequired>
              <FormLabel>{formatMessage({ id: 'reports.reason' })}</FormLabel>
              <Input
                value={reason}
                onChange={(event) => {
                  setReason(event.target.value)
                }}
                aria-label={formatMessage({ id: 'reports.reason' })}
              />
            </FormControl>
          </AlertDialogBody>

          <AlertDialogFooter>
            <Button onClick={onClose}>{formatMessage(messages.cancel)}</Button>
            <Button
              colorScheme="red"
              onClick={() => {
                onConfirm(reason.trim())
              }}
              isDisabled={!reason.trim()}
              ml={3}
            >
              {formatMessage(messages.delete)}
            </Button>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialogOverlay>
    </AlertDialog>
  )
}
